import { render, staticRenderFns } from "./OpeningHoursTable.vue?vue&type=template&id=eac5cb18"
import script from "./OpeningHoursTable.vue?vue&type=script&lang=js"
export * from "./OpeningHoursTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports